import { SecurityCategory } from '../../proto/generated/security'
import { Chip } from '@mui/material'

interface SecurityCategoryItemProps {
    category: SecurityCategory
    selected: boolean
    onSelected: Function
    darkTheme: boolean
    inputRef: any
}

/** TradingView-style category pill. */
export default function SecurityCategoryItem(props: SecurityCategoryItemProps) {
    const { selected } = props

    const handleMouseDown = (e: any) => {
        e.preventDefault()
        props.onSelected(props.category.code)
    }

    return (
        <Chip
            label={props.category.displayName}
            variant={selected ? 'filled' : 'outlined'}
            onMouseDown={handleMouseDown}
            onClick={() => {
                if (!selected) {
                    props.onSelected(props.category.code)
                    props.inputRef.current?.focus()
                }
            }}
            sx={{
                mr: 0.5,
                height: 28,
                borderRadius: '14px',
                fontSize: 13,
                // Keep weight stable so selecting Stocks ↔ Index does not shift chip widths.
                fontWeight: 500,
                flexShrink: 0,
                borderColor: selected ? 'transparent' : 'divider',
                ...(selected
                    ? {
                          bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'grey.200' : 'grey.900'),
                          color: (theme) => (theme.palette.mode === 'dark' ? 'grey.900' : 'common.white'),
                          '&:hover': {
                              bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
                          },
                      }
                    : {
                          bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'action.hover' : 'grey.100'),
                          '&:hover': {
                              bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'action.selected' : 'grey.200'),
                          },
                      }),
            }}
        />
    )
}
